import { gql } from '@apollo/client'

export const getProperties = gql`
  query myProperties {
    myProperties {
      propertyID
      status
      unitNumber
      street
      unitType
      occupancy
      propertyDisplayName
      listings {
        listingID
        status
      }
      image {
        name
        imageUrl
      }
    }
  }
`
